import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";

function timeAgo(ms) {
  const seconds = Math.floor((Date.now() - ms) / 1000);
  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? "" : "s"} ago`;
}

export default function PreviouslyViewed({ items, onSelect, emptyText }) {
  if (!items || items.length === 0) return null;

  return (
    <div className={styles.wrap}>
      <h4 className={styles.heading}>Previously Viewed</h4>
      <ul className={styles.list}>
        {items.map((item) => (
          <li key={item.id}>
            <button
              type="button"
              className={styles.item}
              onClick={() => onSelect(item)}
            >
              <span className={styles.itemName}>
                {item.name}
                {item.sku && <span className={styles.itemSku}> (SKU: {item.sku})</span>}
              </span>
              <span className={styles.itemTime}>
                {timeAgo(item.viewedAt)}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

PreviouslyViewed.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      sku: PropTypes.string,
      url: PropTypes.string,
      viewedAt: PropTypes.number,
    })
  ),
  onSelect: PropTypes.func.isRequired,
  emptyText: PropTypes.string,
};

PreviouslyViewed.defaultProps = {
  items: [],
  emptyText: null,
};
